import React from 'react';
import { Event } from '../../../../../model/event';

import { ResaleSettingInfo } from './ResaleSettingInfo';
import { ResaleOverview } from './ResaleOverview';
import { t } from '../../../../../locales/translate';
import { SalesOverTime } from '../Overview/sales_over_time/sales_over_time';

export function Resale({ event }: { event: Event }): JSX.Element {
  return (
    <>
      <ResaleSettingInfo event={event} />
      <SalesOverTime title={t.model.event.resale.salesOverTime} saleType="product" resale saleId={event.id} />
      <ResaleOverview eventId={event.id} />
    </>
  );
}
